import { Preferences as Storage } from '@capacitor/preferences';
import { isCapacitor } from './platform';

export type PlatformStorage = {
  set: (key: string, value: string) => Promise<void>;

  get: (key: string) => Promise<string | null>;

  remove: (key: string) => Promise<void>;

  isStorageArea: (storage: Storage | null) => boolean;
};

export const capacitorStorage: PlatformStorage = {
  set(key: string, value: string): Promise<void> {
    return Storage.set({ key, value });
  },

  async get(key: string): Promise<string | null> {
    const { value } = await Storage.get({ key });
    return value;
  },

  remove(key: string): Promise<void> {
    return Storage.remove({ key });
  },

  isStorageArea(_: Storage | null) {
    return false;
  },
};

export const webStorage: PlatformStorage = {
  async set(key: string, value: string): Promise<void> {
    return localStorage.setItem(key, value);
  },

  async get(key: string): Promise<string | null> {
    return localStorage.getItem(key);
  },

  async remove(key: string): Promise<void> {
    return localStorage.removeItem(key);
  },

  isStorageArea(storage: Storage | null) {
    return storage === localStorage;
  },
};

export const noopStorage: PlatformStorage = {
  async set(key: string, value: string): Promise<void> {
    return undefined;
  },

  async get(key: string): Promise<string | null> {
    return null;
  },

  async remove(key: string): Promise<void> {
    return undefined;
  },

  isStorageArea(_: Storage | null) {
    return false;
  },
};

export function getPlatformStorage() {
  return isCapacitor() ? capacitorStorage : webStorage;
}
